import styled from "styled-components";

import { smMedia } from "../../../utils/getMediaStyle";
import { font } from "../styles";

const Capital = styled.div`
  font-family: ${font.body};
  left: -18px;
  position: relative;
  font-style: normal;
  font-weight: bold;
  font-size: 144px;
  line-height: 144px;
  color: ${({ theme }) => theme.color.primary.main};
  ${smMedia`
  font-size: 75px;
  line-height: 75px;
  `}
`;

export default Capital;
